import FacilityDocumentTemplatesContent from '@UI/Pages/DocumentTemplates/FacilityDocumentTemplates/FacilityDocumentTemplatesContent';
import DocumentTemplatesNotifications from '@UI/Pages/DocumentTemplates/Shared/DocumentTemplatesNotifications';
import LevelSwitch from '@Guidelines/Component/LevelSwitch';
import PageContainer from '@Guidelines/Layout/PageContainer';
import PageHeader from '@Guidelines/Layout/PageHeader';
import useCurrentOrganization from '@UI/Providers/CurrentOrganizationProvider/useCurrentOrganization';
import useAccessibleNavigationLevels from '@UI/Hooks/useAccessibleNavigationLevels';
import type * as React from 'react';

/**
 * Assembles the screen: header, the data-owning `FacilityDocumentTemplatesContent`, and the
 * notifications shared with the organization screen (`DocumentTemplatesNotifications`, mounted by both
 * — only one of the two is ever on screen at a time). The eyebrow is the section label
 * followed by the current organization's name once resolved; facility selection happens in the header
 * switcher rather than on this page. No sidebar here — depositing, versioning,
 * editing and archiving a gabarit are organization-only actions; this screen only affects the current
 * facility's own affectation, handled entirely inside the shared `TemplateAssignmentCard`.
 */
const FacilityDocumentTemplatesPage: React.FC = () => {
	const { currentOrganization } = useCurrentOrganization();
	const levels = useAccessibleNavigationLevels('document-templates');

	const eyebrow =
		currentOrganization !== null ? `CONFIGURATION · ${currentOrganization.name}` : 'CONFIGURATION';

	return (
		<PageContainer>
			<PageHeader
				eyebrow={eyebrow}
				title="Gabarits de l’agence"
				actions={<LevelSwitch ariaLabel="Niveau des gabarits" levels={levels} />}
			/>
			<FacilityDocumentTemplatesContent />
			<DocumentTemplatesNotifications />
		</PageContainer>
	);
};

export default FacilityDocumentTemplatesPage;
